/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedAccountsIndexRouteImport } from './routes/_authed/accounts/index'
import { Route as AuthedAccountsAccountIdRouteImport } from './routes/_authed/accounts/$accountId'
import { Route as AuthedAccountsAccountIdIndexRouteImport } from './routes/_authed/accounts/$accountId/index'
import { Route as AuthedAccountsAccountIdAskAnnwnRouteRouteImport } from './routes/_authed/accounts/$accountId/ask-annwn/route'
import { Route as AuthedAccountsAccountIdDashboardRouteImport } from './routes/_authed/accounts/$accountId/dashboard'
import { Route as AuthedAccountsAccountIdGraphSearchRouteImport } from './routes/_authed/accounts/$accountId/graph-search'
import { Route as AuthedAccountsAccountIdOntologyRouteImport } from './routes/_authed/accounts/$accountId/ontology'
import { Route as AuthedAccountsAccountIdSettingsRouteImport } from './routes/_authed/accounts/$accountId/settings'
import { Route as AuthedAccountsAccountIdSupportRouteImport } from './routes/_authed/accounts/$accountId/support'
import { Route as AuthedAccountsAccountIdVaultRouteImport } from './routes/_authed/accounts/$accountId/vault'
import { Route as AuthedAccountsAccountIdWhatsNewRouteImport } from './routes/_authed/accounts/$accountId/whats-new'
import { Route as AuthedAccountsAccountIdAskAnnwnIndexRouteImport } from './routes/_authed/accounts/$accountId/ask-annwn/index'
import { Route as AuthedAccountsAccountIdAskAnnwnChatIdRouteImport } from './routes/_authed/accounts/$accountId/ask-annwn/$chatId'
import { Route as AuthedAccountsAccountIdCorpusIndexRouteImport } from './routes/_authed/accounts/$accountId/corpus/index'
import { Route as AuthedAccountsAccountIdCorpusConceptIdRouteImport } from './routes/_authed/accounts/$accountId/corpus/$conceptId'
import { Route as AuthedAccountsAccountIdOntologyIndexRouteImport } from './routes/_authed/accounts/$accountId/ontology/index'
import { Route as AuthedAccountsAccountIdOntologyPromptRouteImport } from './routes/_authed/accounts/$accountId/ontology/prompt'
import { Route as AuthedAccountsAccountIdWorkspacesIndexRouteImport } from './routes/_authed/accounts/$accountId/workspaces/index'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId'
import { Route as AuthedAccountsAccountIdCorpusGuidanceCodeRouteImport } from './routes/_authed/accounts/$accountId/corpus/guidance/$code'
import { Route as AuthedAccountsAccountIdOntologyRelationshipsRelNameRouteImport } from './routes/_authed/accounts/$accountId/ontology/relationships/$relName'
import { Route as AuthedAccountsAccountIdOntologyTypesTypeNameRouteImport } from './routes/_authed/accounts/$accountId/ontology/types/$typeName'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/index'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/documents'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/draft'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/review'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/settings'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/documents/index'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
import { Route as AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRouteImport } from './routes/_authed/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsIndexRoute = AuthedAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsAccountIdRoute = AuthedAccountsAccountIdRouteImport.update({
  id: '/accounts/$accountId',
  path: '/accounts/$accountId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsAccountIdIndexRoute =
  AuthedAccountsAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdAskAnnwnRouteRoute =
  AuthedAccountsAccountIdAskAnnwnRouteRouteImport.update({
    id: '/ask-annwn',
    path: '/ask-annwn',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdDashboardRoute =
  AuthedAccountsAccountIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdGraphSearchRoute =
  AuthedAccountsAccountIdGraphSearchRouteImport.update({
    id: '/graph-search',
    path: '/graph-search',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdOntologyRoute =
  AuthedAccountsAccountIdOntologyRouteImport.update({
    id: '/ontology',
    path: '/ontology',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdSettingsRoute =
  AuthedAccountsAccountIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdSupportRoute =
  AuthedAccountsAccountIdSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdVaultRoute =
  AuthedAccountsAccountIdVaultRouteImport.update({
    id: '/vault',
    path: '/vault',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdWhatsNewRoute =
  AuthedAccountsAccountIdWhatsNewRouteImport.update({
    id: '/whats-new',
    path: '/whats-new',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdAskAnnwnIndexRoute =
  AuthedAccountsAccountIdAskAnnwnIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAccountsAccountIdAskAnnwnRouteRoute,
  } as any)
const AuthedAccountsAccountIdAskAnnwnChatIdRoute =
  AuthedAccountsAccountIdAskAnnwnChatIdRouteImport.update({
    id: '/$chatId',
    path: '/$chatId',
    getParentRoute: () => AuthedAccountsAccountIdAskAnnwnRouteRoute,
  } as any)
const AuthedAccountsAccountIdCorpusIndexRoute =
  AuthedAccountsAccountIdCorpusIndexRouteImport.update({
    id: '/corpus/',
    path: '/corpus/',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdCorpusConceptIdRoute =
  AuthedAccountsAccountIdCorpusConceptIdRouteImport.update({
    id: '/corpus/$conceptId',
    path: '/corpus/$conceptId',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdOntologyIndexRoute =
  AuthedAccountsAccountIdOntologyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAccountsAccountIdOntologyRoute,
  } as any)
const AuthedAccountsAccountIdOntologyPromptRoute =
  AuthedAccountsAccountIdOntologyPromptRouteImport.update({
    id: '/prompt',
    path: '/prompt',
    getParentRoute: () => AuthedAccountsAccountIdOntologyRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesIndexRoute =
  AuthedAccountsAccountIdWorkspacesIndexRouteImport.update({
    id: '/workspaces/',
    path: '/workspaces/',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdCorpusGuidanceCodeRoute =
  AuthedAccountsAccountIdCorpusGuidanceCodeRouteImport.update({
    id: '/corpus/guidance/$code',
    path: '/corpus/guidance/$code',
    getParentRoute: () => AuthedAccountsAccountIdRoute,
  } as any)
const AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute =
  AuthedAccountsAccountIdOntologyRelationshipsRelNameRouteImport.update({
    id: '/relationships/$relName',
    path: '/relationships/$relName',
    getParentRoute: () => AuthedAccountsAccountIdOntologyRoute,
  } as any)
const AuthedAccountsAccountIdOntologyTypesTypeNameRoute =
  AuthedAccountsAccountIdOntologyTypesTypeNameRouteImport.update({
    id: '/types/$typeName',
    path: '/types/$typeName',
    getParentRoute: () => AuthedAccountsAccountIdOntologyRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRouteImport.update({
    id: '/deliverables',
    path: '/deliverables',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRouteImport.update({
    id: '/draft',
    path: '/draft',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute,
  } as any)
const AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRouteImport.update(
    {
      id: '/questions/$questionId',
      path: '/questions/$questionId',
      getParentRoute: () => AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute,
    } as any,
  )
const AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRouteImport.update(
    {
      id: '/$fileUploadId/candidates',
      path: '/$fileUploadId/candidates',
      getParentRoute: () =>
        AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/users': typeof AuthedUsersRoute
  '/accounts/$accountId': typeof AuthedAccountsAccountIdRouteWithChildren
  '/accounts/': typeof AuthedAccountsIndexRoute
  '/accounts/$accountId/ask-annwn': typeof AuthedAccountsAccountIdAskAnnwnRouteRouteWithChildren
  '/accounts/$accountId/dashboard': typeof AuthedAccountsAccountIdDashboardRoute
  '/accounts/$accountId/graph-search': typeof AuthedAccountsAccountIdGraphSearchRoute
  '/accounts/$accountId/ontology': typeof AuthedAccountsAccountIdOntologyRouteWithChildren
  '/accounts/$accountId/settings': typeof AuthedAccountsAccountIdSettingsRoute
  '/accounts/$accountId/support': typeof AuthedAccountsAccountIdSupportRoute
  '/accounts/$accountId/vault': typeof AuthedAccountsAccountIdVaultRoute
  '/accounts/$accountId/whats-new': typeof AuthedAccountsAccountIdWhatsNewRoute
  '/accounts/$accountId/': typeof AuthedAccountsAccountIdIndexRoute
  '/accounts/$accountId/ask-annwn/$chatId': typeof AuthedAccountsAccountIdAskAnnwnChatIdRoute
  '/accounts/$accountId/corpus/$conceptId': typeof AuthedAccountsAccountIdCorpusConceptIdRoute
  '/accounts/$accountId/ontology/prompt': typeof AuthedAccountsAccountIdOntologyPromptRoute
  '/accounts/$accountId/workspaces/$workspaceId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteWithChildren
  '/accounts/$accountId/ask-annwn/': typeof AuthedAccountsAccountIdAskAnnwnIndexRoute
  '/accounts/$accountId/corpus/': typeof AuthedAccountsAccountIdCorpusIndexRoute
  '/accounts/$accountId/ontology/': typeof AuthedAccountsAccountIdOntologyIndexRoute
  '/accounts/$accountId/workspaces/': typeof AuthedAccountsAccountIdWorkspacesIndexRoute
  '/accounts/$accountId/corpus/guidance/$code': typeof AuthedAccountsAccountIdCorpusGuidanceCodeRoute
  '/accounts/$accountId/ontology/relationships/$relName': typeof AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute
  '/accounts/$accountId/ontology/types/$typeName': typeof AuthedAccountsAccountIdOntologyTypesTypeNameRoute
  '/accounts/$accountId/workspaces/$workspaceId/deliverables': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute
  '/accounts/$accountId/workspaces/$workspaceId/documents': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteWithChildren
  '/accounts/$accountId/workspaces/$workspaceId/draft': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute
  '/accounts/$accountId/workspaces/$workspaceId/review': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute
  '/accounts/$accountId/workspaces/$workspaceId/settings': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute
  '/accounts/$accountId/workspaces/$workspaceId/': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute
  '/accounts/$accountId/workspaces/$workspaceId/questions/$questionId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute
  '/accounts/$accountId/workspaces/$workspaceId/documents/': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute
  '/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/users': typeof AuthedUsersRoute
  '/': typeof AuthedIndexRoute
  '/accounts': typeof AuthedAccountsIndexRoute
  '/accounts/$accountId/dashboard': typeof AuthedAccountsAccountIdDashboardRoute
  '/accounts/$accountId/graph-search': typeof AuthedAccountsAccountIdGraphSearchRoute
  '/accounts/$accountId/settings': typeof AuthedAccountsAccountIdSettingsRoute
  '/accounts/$accountId/support': typeof AuthedAccountsAccountIdSupportRoute
  '/accounts/$accountId/vault': typeof AuthedAccountsAccountIdVaultRoute
  '/accounts/$accountId/whats-new': typeof AuthedAccountsAccountIdWhatsNewRoute
  '/accounts/$accountId': typeof AuthedAccountsAccountIdIndexRoute
  '/accounts/$accountId/ask-annwn/$chatId': typeof AuthedAccountsAccountIdAskAnnwnChatIdRoute
  '/accounts/$accountId/corpus/$conceptId': typeof AuthedAccountsAccountIdCorpusConceptIdRoute
  '/accounts/$accountId/ontology/prompt': typeof AuthedAccountsAccountIdOntologyPromptRoute
  '/accounts/$accountId/ask-annwn': typeof AuthedAccountsAccountIdAskAnnwnIndexRoute
  '/accounts/$accountId/corpus': typeof AuthedAccountsAccountIdCorpusIndexRoute
  '/accounts/$accountId/ontology': typeof AuthedAccountsAccountIdOntologyIndexRoute
  '/accounts/$accountId/workspaces': typeof AuthedAccountsAccountIdWorkspacesIndexRoute
  '/accounts/$accountId/corpus/guidance/$code': typeof AuthedAccountsAccountIdCorpusGuidanceCodeRoute
  '/accounts/$accountId/ontology/relationships/$relName': typeof AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute
  '/accounts/$accountId/ontology/types/$typeName': typeof AuthedAccountsAccountIdOntologyTypesTypeNameRoute
  '/accounts/$accountId/workspaces/$workspaceId/deliverables': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute
  '/accounts/$accountId/workspaces/$workspaceId/draft': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute
  '/accounts/$accountId/workspaces/$workspaceId/review': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute
  '/accounts/$accountId/workspaces/$workspaceId/settings': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute
  '/accounts/$accountId/workspaces/$workspaceId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute
  '/accounts/$accountId/workspaces/$workspaceId/questions/$questionId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute
  '/accounts/$accountId/workspaces/$workspaceId/documents': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute
  '/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/accounts/$accountId': typeof AuthedAccountsAccountIdRouteWithChildren
  '/_authed/accounts/': typeof AuthedAccountsIndexRoute
  '/_authed/accounts/$accountId/ask-annwn': typeof AuthedAccountsAccountIdAskAnnwnRouteRouteWithChildren
  '/_authed/accounts/$accountId/dashboard': typeof AuthedAccountsAccountIdDashboardRoute
  '/_authed/accounts/$accountId/graph-search': typeof AuthedAccountsAccountIdGraphSearchRoute
  '/_authed/accounts/$accountId/ontology': typeof AuthedAccountsAccountIdOntologyRouteWithChildren
  '/_authed/accounts/$accountId/settings': typeof AuthedAccountsAccountIdSettingsRoute
  '/_authed/accounts/$accountId/support': typeof AuthedAccountsAccountIdSupportRoute
  '/_authed/accounts/$accountId/vault': typeof AuthedAccountsAccountIdVaultRoute
  '/_authed/accounts/$accountId/whats-new': typeof AuthedAccountsAccountIdWhatsNewRoute
  '/_authed/accounts/$accountId/': typeof AuthedAccountsAccountIdIndexRoute
  '/_authed/accounts/$accountId/ask-annwn/$chatId': typeof AuthedAccountsAccountIdAskAnnwnChatIdRoute
  '/_authed/accounts/$accountId/corpus/$conceptId': typeof AuthedAccountsAccountIdCorpusConceptIdRoute
  '/_authed/accounts/$accountId/ontology/prompt': typeof AuthedAccountsAccountIdOntologyPromptRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteWithChildren
  '/_authed/accounts/$accountId/ask-annwn/': typeof AuthedAccountsAccountIdAskAnnwnIndexRoute
  '/_authed/accounts/$accountId/corpus/': typeof AuthedAccountsAccountIdCorpusIndexRoute
  '/_authed/accounts/$accountId/ontology/': typeof AuthedAccountsAccountIdOntologyIndexRoute
  '/_authed/accounts/$accountId/workspaces/': typeof AuthedAccountsAccountIdWorkspacesIndexRoute
  '/_authed/accounts/$accountId/corpus/guidance/$code': typeof AuthedAccountsAccountIdCorpusGuidanceCodeRoute
  '/_authed/accounts/$accountId/ontology/relationships/$relName': typeof AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute
  '/_authed/accounts/$accountId/ontology/types/$typeName': typeof AuthedAccountsAccountIdOntologyTypesTypeNameRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/documents': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteWithChildren
  '/_authed/accounts/$accountId/workspaces/$workspaceId/draft': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/review': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/settings': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/questions/$questionId': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute
  '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates': typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/users'
    | '/accounts/$accountId'
    | '/accounts/'
    | '/accounts/$accountId/ask-annwn'
    | '/accounts/$accountId/dashboard'
    | '/accounts/$accountId/graph-search'
    | '/accounts/$accountId/ontology'
    | '/accounts/$accountId/settings'
    | '/accounts/$accountId/support'
    | '/accounts/$accountId/vault'
    | '/accounts/$accountId/whats-new'
    | '/accounts/$accountId/'
    | '/accounts/$accountId/ask-annwn/$chatId'
    | '/accounts/$accountId/corpus/$conceptId'
    | '/accounts/$accountId/ontology/prompt'
    | '/accounts/$accountId/workspaces/$workspaceId'
    | '/accounts/$accountId/ask-annwn/'
    | '/accounts/$accountId/corpus/'
    | '/accounts/$accountId/ontology/'
    | '/accounts/$accountId/workspaces/'
    | '/accounts/$accountId/corpus/guidance/$code'
    | '/accounts/$accountId/ontology/relationships/$relName'
    | '/accounts/$accountId/ontology/types/$typeName'
    | '/accounts/$accountId/workspaces/$workspaceId/deliverables'
    | '/accounts/$accountId/workspaces/$workspaceId/documents'
    | '/accounts/$accountId/workspaces/$workspaceId/draft'
    | '/accounts/$accountId/workspaces/$workspaceId/review'
    | '/accounts/$accountId/workspaces/$workspaceId/settings'
    | '/accounts/$accountId/workspaces/$workspaceId/'
    | '/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
    | '/accounts/$accountId/workspaces/$workspaceId/documents/'
    | '/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/users'
    | '/'
    | '/accounts'
    | '/accounts/$accountId/dashboard'
    | '/accounts/$accountId/graph-search'
    | '/accounts/$accountId/settings'
    | '/accounts/$accountId/support'
    | '/accounts/$accountId/vault'
    | '/accounts/$accountId/whats-new'
    | '/accounts/$accountId'
    | '/accounts/$accountId/ask-annwn/$chatId'
    | '/accounts/$accountId/corpus/$conceptId'
    | '/accounts/$accountId/ontology/prompt'
    | '/accounts/$accountId/ask-annwn'
    | '/accounts/$accountId/corpus'
    | '/accounts/$accountId/ontology'
    | '/accounts/$accountId/workspaces'
    | '/accounts/$accountId/corpus/guidance/$code'
    | '/accounts/$accountId/ontology/relationships/$relName'
    | '/accounts/$accountId/ontology/types/$typeName'
    | '/accounts/$accountId/workspaces/$workspaceId/deliverables'
    | '/accounts/$accountId/workspaces/$workspaceId/draft'
    | '/accounts/$accountId/workspaces/$workspaceId/review'
    | '/accounts/$accountId/workspaces/$workspaceId/settings'
    | '/accounts/$accountId/workspaces/$workspaceId'
    | '/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
    | '/accounts/$accountId/workspaces/$workspaceId/documents'
    | '/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/users'
    | '/_authed/'
    | '/_authed/accounts/$accountId'
    | '/_authed/accounts/'
    | '/_authed/accounts/$accountId/ask-annwn'
    | '/_authed/accounts/$accountId/dashboard'
    | '/_authed/accounts/$accountId/graph-search'
    | '/_authed/accounts/$accountId/ontology'
    | '/_authed/accounts/$accountId/settings'
    | '/_authed/accounts/$accountId/support'
    | '/_authed/accounts/$accountId/vault'
    | '/_authed/accounts/$accountId/whats-new'
    | '/_authed/accounts/$accountId/'
    | '/_authed/accounts/$accountId/ask-annwn/$chatId'
    | '/_authed/accounts/$accountId/corpus/$conceptId'
    | '/_authed/accounts/$accountId/ontology/prompt'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId'
    | '/_authed/accounts/$accountId/ask-annwn/'
    | '/_authed/accounts/$accountId/corpus/'
    | '/_authed/accounts/$accountId/ontology/'
    | '/_authed/accounts/$accountId/workspaces/'
    | '/_authed/accounts/$accountId/corpus/guidance/$code'
    | '/_authed/accounts/$accountId/ontology/relationships/$relName'
    | '/_authed/accounts/$accountId/ontology/types/$typeName'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/documents'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/draft'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/review'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/settings'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/'
    | '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts/': {
      id: '/_authed/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthedAccountsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts/$accountId': {
      id: '/_authed/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AuthedAccountsAccountIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts/$accountId/': {
      id: '/_authed/accounts/$accountId/'
      path: '/'
      fullPath: '/accounts/$accountId/'
      preLoaderRoute: typeof AuthedAccountsAccountIdIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/ask-annwn': {
      id: '/_authed/accounts/$accountId/ask-annwn'
      path: '/ask-annwn'
      fullPath: '/accounts/$accountId/ask-annwn'
      preLoaderRoute: typeof AuthedAccountsAccountIdAskAnnwnRouteRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/dashboard': {
      id: '/_authed/accounts/$accountId/dashboard'
      path: '/dashboard'
      fullPath: '/accounts/$accountId/dashboard'
      preLoaderRoute: typeof AuthedAccountsAccountIdDashboardRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/graph-search': {
      id: '/_authed/accounts/$accountId/graph-search'
      path: '/graph-search'
      fullPath: '/accounts/$accountId/graph-search'
      preLoaderRoute: typeof AuthedAccountsAccountIdGraphSearchRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/ontology': {
      id: '/_authed/accounts/$accountId/ontology'
      path: '/ontology'
      fullPath: '/accounts/$accountId/ontology'
      preLoaderRoute: typeof AuthedAccountsAccountIdOntologyRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/settings': {
      id: '/_authed/accounts/$accountId/settings'
      path: '/settings'
      fullPath: '/accounts/$accountId/settings'
      preLoaderRoute: typeof AuthedAccountsAccountIdSettingsRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/support': {
      id: '/_authed/accounts/$accountId/support'
      path: '/support'
      fullPath: '/accounts/$accountId/support'
      preLoaderRoute: typeof AuthedAccountsAccountIdSupportRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/vault': {
      id: '/_authed/accounts/$accountId/vault'
      path: '/vault'
      fullPath: '/accounts/$accountId/vault'
      preLoaderRoute: typeof AuthedAccountsAccountIdVaultRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/whats-new': {
      id: '/_authed/accounts/$accountId/whats-new'
      path: '/whats-new'
      fullPath: '/accounts/$accountId/whats-new'
      preLoaderRoute: typeof AuthedAccountsAccountIdWhatsNewRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/ask-annwn/': {
      id: '/_authed/accounts/$accountId/ask-annwn/'
      path: '/'
      fullPath: '/accounts/$accountId/ask-annwn/'
      preLoaderRoute: typeof AuthedAccountsAccountIdAskAnnwnIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdAskAnnwnRouteRoute
    }
    '/_authed/accounts/$accountId/ask-annwn/$chatId': {
      id: '/_authed/accounts/$accountId/ask-annwn/$chatId'
      path: '/$chatId'
      fullPath: '/accounts/$accountId/ask-annwn/$chatId'
      preLoaderRoute: typeof AuthedAccountsAccountIdAskAnnwnChatIdRouteImport
      parentRoute: typeof AuthedAccountsAccountIdAskAnnwnRouteRoute
    }
    '/_authed/accounts/$accountId/corpus/': {
      id: '/_authed/accounts/$accountId/corpus/'
      path: '/corpus'
      fullPath: '/accounts/$accountId/corpus/'
      preLoaderRoute: typeof AuthedAccountsAccountIdCorpusIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/corpus/$conceptId': {
      id: '/_authed/accounts/$accountId/corpus/$conceptId'
      path: '/corpus/$conceptId'
      fullPath: '/accounts/$accountId/corpus/$conceptId'
      preLoaderRoute: typeof AuthedAccountsAccountIdCorpusConceptIdRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/ontology/': {
      id: '/_authed/accounts/$accountId/ontology/'
      path: '/'
      fullPath: '/accounts/$accountId/ontology/'
      preLoaderRoute: typeof AuthedAccountsAccountIdOntologyIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdOntologyRoute
    }
    '/_authed/accounts/$accountId/ontology/prompt': {
      id: '/_authed/accounts/$accountId/ontology/prompt'
      path: '/prompt'
      fullPath: '/accounts/$accountId/ontology/prompt'
      preLoaderRoute: typeof AuthedAccountsAccountIdOntologyPromptRouteImport
      parentRoute: typeof AuthedAccountsAccountIdOntologyRoute
    }
    '/_authed/accounts/$accountId/workspaces/': {
      id: '/_authed/accounts/$accountId/workspaces/'
      path: '/workspaces'
      fullPath: '/accounts/$accountId/workspaces/'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/corpus/guidance/$code': {
      id: '/_authed/accounts/$accountId/corpus/guidance/$code'
      path: '/corpus/guidance/$code'
      fullPath: '/accounts/$accountId/corpus/guidance/$code'
      preLoaderRoute: typeof AuthedAccountsAccountIdCorpusGuidanceCodeRouteImport
      parentRoute: typeof AuthedAccountsAccountIdRoute
    }
    '/_authed/accounts/$accountId/ontology/relationships/$relName': {
      id: '/_authed/accounts/$accountId/ontology/relationships/$relName'
      path: '/relationships/$relName'
      fullPath: '/accounts/$accountId/ontology/relationships/$relName'
      preLoaderRoute: typeof AuthedAccountsAccountIdOntologyRelationshipsRelNameRouteImport
      parentRoute: typeof AuthedAccountsAccountIdOntologyRoute
    }
    '/_authed/accounts/$accountId/ontology/types/$typeName': {
      id: '/_authed/accounts/$accountId/ontology/types/$typeName'
      path: '/types/$typeName'
      fullPath: '/accounts/$accountId/ontology/types/$typeName'
      preLoaderRoute: typeof AuthedAccountsAccountIdOntologyTypesTypeNameRouteImport
      parentRoute: typeof AuthedAccountsAccountIdOntologyRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables'
      path: '/deliverables'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/deliverables'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/documents': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/documents'
      path: '/documents'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/documents'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/draft': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/draft'
      path: '/draft'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/draft'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/review': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/review'
      path: '/review'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/review'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/settings': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/'
      path: '/'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/documents/'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/questions/$questionId': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
      path: '/questions/$questionId'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/questions/$questionId'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates': {
      id: '/_authed/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'
      path: '/$fileUploadId/candidates'
      fullPath: '/accounts/$accountId/workspaces/$workspaceId/documents/$fileUploadId/candidates'
      preLoaderRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRouteImport
      parentRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute
    }
  }
}

interface AuthedAccountsAccountIdAskAnnwnRouteRouteChildren {
  AuthedAccountsAccountIdAskAnnwnChatIdRoute: typeof AuthedAccountsAccountIdAskAnnwnChatIdRoute
  AuthedAccountsAccountIdAskAnnwnIndexRoute: typeof AuthedAccountsAccountIdAskAnnwnIndexRoute
}

const AuthedAccountsAccountIdAskAnnwnRouteRouteChildren: AuthedAccountsAccountIdAskAnnwnRouteRouteChildren =
  {
    AuthedAccountsAccountIdAskAnnwnChatIdRoute:
      AuthedAccountsAccountIdAskAnnwnChatIdRoute,
    AuthedAccountsAccountIdAskAnnwnIndexRoute:
      AuthedAccountsAccountIdAskAnnwnIndexRoute,
  }

const AuthedAccountsAccountIdAskAnnwnRouteRouteWithChildren =
  AuthedAccountsAccountIdAskAnnwnRouteRoute._addFileChildren(
    AuthedAccountsAccountIdAskAnnwnRouteRouteChildren,
  )

interface AuthedAccountsAccountIdOntologyRouteChildren {
  AuthedAccountsAccountIdOntologyPromptRoute: typeof AuthedAccountsAccountIdOntologyPromptRoute
  AuthedAccountsAccountIdOntologyIndexRoute: typeof AuthedAccountsAccountIdOntologyIndexRoute
  AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute: typeof AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute
  AuthedAccountsAccountIdOntologyTypesTypeNameRoute: typeof AuthedAccountsAccountIdOntologyTypesTypeNameRoute
}

const AuthedAccountsAccountIdOntologyRouteChildren: AuthedAccountsAccountIdOntologyRouteChildren =
  {
    AuthedAccountsAccountIdOntologyPromptRoute:
      AuthedAccountsAccountIdOntologyPromptRoute,
    AuthedAccountsAccountIdOntologyIndexRoute:
      AuthedAccountsAccountIdOntologyIndexRoute,
    AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute:
      AuthedAccountsAccountIdOntologyRelationshipsRelNameRoute,
    AuthedAccountsAccountIdOntologyTypesTypeNameRoute:
      AuthedAccountsAccountIdOntologyTypesTypeNameRoute,
  }

const AuthedAccountsAccountIdOntologyRouteWithChildren =
  AuthedAccountsAccountIdOntologyRoute._addFileChildren(
    AuthedAccountsAccountIdOntologyRouteChildren,
  )

interface AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteChildren {
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute
}

const AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteChildren: AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteChildren =
  {
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsIndexRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsFileUploadIdCandidatesRoute,
  }

const AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteWithChildren =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute._addFileChildren(
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteChildren,
  )

interface AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteChildren {
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteWithChildren
  AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute
}

const AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteChildren: AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteChildren =
  {
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDeliverablesRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDocumentsRouteWithChildren,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdDraftRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdReviewRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdSettingsRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdIndexRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdQuestionsQuestionIdRoute,
  }

const AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteWithChildren =
  AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteChildren,
  )

interface AuthedAccountsAccountIdRouteChildren {
  AuthedAccountsAccountIdAskAnnwnRouteRoute: typeof AuthedAccountsAccountIdAskAnnwnRouteRouteWithChildren
  AuthedAccountsAccountIdDashboardRoute: typeof AuthedAccountsAccountIdDashboardRoute
  AuthedAccountsAccountIdGraphSearchRoute: typeof AuthedAccountsAccountIdGraphSearchRoute
  AuthedAccountsAccountIdOntologyRoute: typeof AuthedAccountsAccountIdOntologyRouteWithChildren
  AuthedAccountsAccountIdSettingsRoute: typeof AuthedAccountsAccountIdSettingsRoute
  AuthedAccountsAccountIdSupportRoute: typeof AuthedAccountsAccountIdSupportRoute
  AuthedAccountsAccountIdVaultRoute: typeof AuthedAccountsAccountIdVaultRoute
  AuthedAccountsAccountIdWhatsNewRoute: typeof AuthedAccountsAccountIdWhatsNewRoute
  AuthedAccountsAccountIdIndexRoute: typeof AuthedAccountsAccountIdIndexRoute
  AuthedAccountsAccountIdCorpusConceptIdRoute: typeof AuthedAccountsAccountIdCorpusConceptIdRoute
  AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute: typeof AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteWithChildren
  AuthedAccountsAccountIdCorpusIndexRoute: typeof AuthedAccountsAccountIdCorpusIndexRoute
  AuthedAccountsAccountIdWorkspacesIndexRoute: typeof AuthedAccountsAccountIdWorkspacesIndexRoute
  AuthedAccountsAccountIdCorpusGuidanceCodeRoute: typeof AuthedAccountsAccountIdCorpusGuidanceCodeRoute
}

const AuthedAccountsAccountIdRouteChildren: AuthedAccountsAccountIdRouteChildren =
  {
    AuthedAccountsAccountIdAskAnnwnRouteRoute:
      AuthedAccountsAccountIdAskAnnwnRouteRouteWithChildren,
    AuthedAccountsAccountIdDashboardRoute:
      AuthedAccountsAccountIdDashboardRoute,
    AuthedAccountsAccountIdGraphSearchRoute:
      AuthedAccountsAccountIdGraphSearchRoute,
    AuthedAccountsAccountIdOntologyRoute:
      AuthedAccountsAccountIdOntologyRouteWithChildren,
    AuthedAccountsAccountIdSettingsRoute: AuthedAccountsAccountIdSettingsRoute,
    AuthedAccountsAccountIdSupportRoute: AuthedAccountsAccountIdSupportRoute,
    AuthedAccountsAccountIdVaultRoute: AuthedAccountsAccountIdVaultRoute,
    AuthedAccountsAccountIdWhatsNewRoute: AuthedAccountsAccountIdWhatsNewRoute,
    AuthedAccountsAccountIdIndexRoute: AuthedAccountsAccountIdIndexRoute,
    AuthedAccountsAccountIdCorpusConceptIdRoute:
      AuthedAccountsAccountIdCorpusConceptIdRoute,
    AuthedAccountsAccountIdWorkspacesWorkspaceIdRoute:
      AuthedAccountsAccountIdWorkspacesWorkspaceIdRouteWithChildren,
    AuthedAccountsAccountIdCorpusIndexRoute:
      AuthedAccountsAccountIdCorpusIndexRoute,
    AuthedAccountsAccountIdWorkspacesIndexRoute:
      AuthedAccountsAccountIdWorkspacesIndexRoute,
    AuthedAccountsAccountIdCorpusGuidanceCodeRoute:
      AuthedAccountsAccountIdCorpusGuidanceCodeRoute,
  }

const AuthedAccountsAccountIdRouteWithChildren =
  AuthedAccountsAccountIdRoute._addFileChildren(
    AuthedAccountsAccountIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAccountsAccountIdRoute: typeof AuthedAccountsAccountIdRouteWithChildren
  AuthedAccountsIndexRoute: typeof AuthedAccountsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAccountsAccountIdRoute: AuthedAccountsAccountIdRouteWithChildren,
  AuthedAccountsIndexRoute: AuthedAccountsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
